module.exports = __webpack_public_path__ + "static/media/icon-apartment.0a524266.svg";